import { config } from 'config';
import { appConfig } from './app';

export const menus = [
  {
    name: config.security.roleNames.undefinedRoleName,
    options: [],
  },
  {
    name: config.security.roleNames.superAdminRoleName,
    options: [
      {
        title: 'Solicitudes',
        link:
          appConfig.react_routes.prefix +
          appConfig.react_routes.modules.conciliationAdmin.prefix +
          appConfig.react_routes.modules.conciliationAdmin.services.home,
        icon: 'usersIcon',
      },
      {
        title: 'Usuarios',
        link:
          config.react_routes.prefix +
          config.react_routes.modules.userAdmin.prefix +
          config.react_routes.modules.userAdmin.services.home,
        icon: 'usersIcon',
      },
      {
        title: 'Notificaciones',
        link:
          config.react_routes.prefix +
          config.react_routes.modules.notification.prefix +
          config.react_routes.modules.notification.services.home,
        icon: 'notificationIcon',
      },
      {
        title: 'Configuración',
        link:
          config.react_routes.prefix +
          config.react_routes.modules.config.prefix +
          config.react_routes.modules.config.services.friendly,
        icon: 'settingsIcon',
      },
      {
        title: 'Config. Detallada',
        link:
          config.react_routes.prefix +
          config.react_routes.modules.config.prefix +
          config.react_routes.modules.config.services.home,
        icon: 'settingsIcon',
      },
      {
        title: 'Auditoría',
        link:
          config.react_routes.prefix +
          config.react_routes.modules.audit.prefix +
          config.react_routes.modules.audit.services.home,
        icon: 'auditIcon',
      },
    ],
  },
  {
    name: config.security.roleNames.superAdminFSJPRoleName,
    options: [
      {
        title: 'Solicitudes',
        link:
          appConfig.react_routes.prefix +
          appConfig.react_routes.modules.conciliationAdmin.prefix +
          appConfig.react_routes.modules.conciliationAdmin.services.home,
        icon: 'usersIcon',
      },
      {
        title: 'Buzón Ético',
        link:
          appConfig.react_routes.prefix +
          appConfig.react_routes.modules.ethicalInboxAdmin.prefix +
          appConfig.react_routes.modules.conciliationAdmin.services.home,
        icon: 'usersIcon',
      },
      {
        title: 'Usuarios',
        link:
          config.react_routes.prefix +
          config.react_routes.modules.userAdmin.prefix +
          config.react_routes.modules.userAdmin.services.home,
        icon: 'usersIcon',
      },
      {
        title: 'Notificaciones',
        link:
          config.react_routes.prefix +
          config.react_routes.modules.notification.prefix +
          config.react_routes.modules.notification.services.home,
        icon: 'notificationIcon',
      },
      {
        title: 'Configuración',
        link:
          config.react_routes.prefix +
          config.react_routes.modules.config.prefix +
          config.react_routes.modules.config.services.friendly,
        icon: 'settingsIcon',
      },
      {
        title: 'Config. Detallada',
        link:
          config.react_routes.prefix +
          config.react_routes.modules.config.prefix +
          config.react_routes.modules.config.services.home,
        icon: 'settingsIcon',
      },
      {
        title: 'Auditoría',
        link:
          config.react_routes.prefix +
          config.react_routes.modules.audit.prefix +
          config.react_routes.modules.audit.services.home,
        icon: 'auditIcon',
      },
    ],
  },
  {
    name: config.security.roleNames.standarUserRoleName,
    options: [
      {
        title: 'Inicio',
        link: config.react_routes.prefix,
        icon: 'homeIcon',
      },
      {
        title: 'Solicitudes',
        link:
          appConfig.react_routes.prefix +
          appConfig.react_routes.modules.conciliationAdmin.prefix +
          appConfig.react_routes.modules.conciliationAdmin.services.home,
        icon: 'usersIcon',
      },
    ],
  },
];
